import PopupComponent from './container'

export default PopupComponent
